import { FC, PropsWithChildren } from "react";
import { Aside, Header } from "../organisms";

const fullContentStyle = {
  maxWidth: "100%",
};

export const MasterLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <>
      <main className="d-flex flex-column flex-root">
        <div className="page d-flex flex-row flex-column-fluid">
          <Aside />
          <div id="kt_wrapper" className="wrapper d-flex flex-column flex-row-fluid">
            <Header />
            <div id="kt_content" className="content d-flex flex-column flex-column-fluid">
              {/* <Toolbar /> */}
              <div id="kt_post" className="post d-flex flex-column-fluid">
                <div id="kt_content_container" className="px-32 container-xxl" style={fullContentStyle}>
                  {children}
                </div>
              </div>
            </div>
            {/* <Footer /> */}
          </div>
        </div>
      </main>
      {/* <ScrollTop /> */}
    </>
  );
};

